import { render, staticRenderFns } from "./billing.vue?vue&type=template&id=ed52df08&scoped=true"
import script from "./billing.vue?vue&type=script&lang=js"
export * from "./billing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed52df08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed52df08')) {
      api.createRecord('ed52df08', component.options)
    } else {
      api.reload('ed52df08', component.options)
    }
    module.hot.accept("./billing.vue?vue&type=template&id=ed52df08&scoped=true", function () {
      api.rerender('ed52df08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/billing.vue"
export default component.exports